import {
  getCurrentCalendarDateTime,
  validateTypeAndDescriptionNullable,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/transformers";
import {
  DescribedType,
  describedTypeSchema,
} from "features/CenterContent/shared/operationalInformation/utils";
import {
  DateTimeForm,
  dateTimeFormToRequest,
  dateTimeSchemaRequest,
  dateTimeSchemaResponse,
} from "shared/form/dateTimeSchema";
import { Nullable } from "shared/utils/objectUtils";
import z from "zod";

export const prognosisResponseSchema = describedTypeSchema
  .nullish()
  .and(
    z.object({
      estimatedResolved: dateTimeSchemaResponse.nullish(),
      estimatedInfoUpdate: dateTimeSchemaResponse.nullish(),
    }),
  )
  .nullable();

export type PrognosisResponse = z.infer<typeof prognosisResponseSchema>;

export const PrognosisSchema = describedTypeSchema
  .nullish()
  .and(
    z.object({
      estimatedResolved: dateTimeSchemaRequest.nullish(),
      estimatedInfoUpdate: dateTimeSchemaRequest.nullish(),
    }),
  )
  .nullable();

export type Prognosis = z.infer<typeof PrognosisSchema>;

export const validatePrognosis = (
  field: Nullable<DescribedType>,
  prognosisTime: DateTimeForm,
): Prognosis => {
  const validatedPrognosis = validateTypeAndDescriptionNullable(field);
  if (!validatedPrognosis) return null;
  const { type, description } = validatedPrognosis;
  const estimatedResolved =
    type === "ESTIMATED_OPENING" ? dateTimeFormToRequest(prognosisTime) : null;
  const estimatedInfoUpdate =
    type === "ESTIMATED_INFO_UPDATE"
      ? dateTimeFormToRequest(prognosisTime)
      : null;
  return {
    type,
    description,
    estimatedResolved,
    estimatedInfoUpdate,
  };
};

export const getPrognosisTime = (prognosis: PrognosisResponse) => {
  if (prognosis) {
    if (prognosis.type === "ESTIMATED_OPENING" && prognosis.estimatedResolved)
      return prognosis.estimatedResolved;
    if (
      prognosis.type === "ESTIMATED_INFO_UPDATE" &&
      prognosis.estimatedInfoUpdate
    )
      return prognosis.estimatedInfoUpdate;
  }
  return getCurrentCalendarDateTime();
};

export const getDefaultPrognosis = () => ({
  prognosisType: null,
  prognosisTime: getCurrentCalendarDateTime(),
});
